import slider1 from '../../assets/images/slider/webp/slider-1.webp';
import slider2 from '../../assets/images/slider/webp/slider-2.webp';
import slider3 from '../../assets/images/slider/webp/slider-3.webp';

export const imgs = [slider3, slider2, slider1,];
